import { AbstractCollectionDirective } from './abstract-collection.directive';
import { Component } from '@angular/core';

@Component({
  templateUrl: './environment-detail.component.html',
  styleUrls: ['./ie11-fixes.scss'],
})
export class EnvironmentDetailComponent extends AbstractCollectionDirective {}
